import { licensureActionType } from 'redux/actionsTypes';
import produce from 'immer';
import { IProfileLicensuresObject } from '../../../@types/profile-types';
import mockLicensureData from 'assets/data/profile/licensure.json';

const initialData: IProfileLicensuresObject[] = mockLicensureData.data as IProfileLicensuresObject[];

export interface IProfileLicensuresInfo {
    error: boolean;
    data: IProfileLicensuresObject[];
    loading: boolean;
}

interface IprofileLicensuresAction {
    type: string;
    payload: IProfileLicensuresObject[];
}

const initialStateData = {
    error: false,
    data: [initialData[0]],
    loading: false,
};

const reducer = (
    state: IProfileLicensuresInfo = initialStateData,
    action: IprofileLicensuresAction
) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case licensureActionType.PROFILE_LICENSURES_ERROR:
                draft.error = true;
                draft.data = [];
                draft.loading = false;
                return draft;
            case licensureActionType.PROFILE_LICENSURES_LOADING:
                draft.error = false;
                draft.data = [initialData[0]];
                draft.loading = true;
                return draft;
            case licensureActionType.PROFILE_LICENSURES_SUCCESS:
                draft.error = false;
                draft.data = action.payload;
                draft.loading = false;
                return draft;
        }
        return state;
    });
};

export default reducer;
